const state = {
  childrenParentId: '',
  selectedFolderId: '',
  selectedNodePath: JSON.parse(localStorage.getItem('selectedNodePath')) || [],
  updateRightView: false,
  folderLoadFinished: true
}

const getters = {
  childrenParentId: (state) => { return state.childrenParentId },
  selectedFolderId: (state) => { return state.selectedFolderId },
  selectedNodePath: (state) => { return state.selectedNodePath },
  getUpdateRightView: (state) => { return state.updateRightView },
  folderLoadFinished: (state) => { return state.folderLoadFinished }
}

const actions = {
}

const mutations = {
  setChildrenParentId (state, id) {
    state.childrenParentId = id
  },
  setFolderPath (state, pathArray) {
    state.selectedNodePath = pathArray
  },
  setSelectedFolderId (state, {id, integerId}) {
    if (id) localStorage.setItem('selectedFolderId', id)
    if (integerId) localStorage.setItem('selectedFolderIntegerId', integerId)
    state.selectedFolderId = id
  },
  setUpdateRightView (state, value) {
    state.updateRightView = value
  },
  setFolderLoadFinished (state, value) {
    state.folderLoadFinished = value
  }
}

export const module = {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/Store/modules/treeViewModule.js